import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, Routes, Route } from "react-router-dom";

import "./html.css";
import { auth } from "../../components/firebase/firebase";

import HtmlGeneratorStart from "./HtmlGeneratorStart";

function HtmlGenerator() {
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/login");
  }, [user, loading]);

  return (
    <div className="HtmlGenerator">
      <Routes>
        <Route path="/" element={<HtmlGeneratorStart />} />
      </Routes>
    </div>
  );
}

export default HtmlGenerator;
